<ng-container *ngIf="appState$ | async as appState">
  <div
    class="banner-principal-bloque"
    *ngIf="!appState.ui.mobileLayout">

    <!-- <video
      muted
      autoplay
      loop
      #videoPlayer
      class="banner-video">
      <source
        src="assets/img/web/banner-siu2.mp4"
        type="video/mp4">
      <source
        src="assets/img/web/banner-siu.ogv"
        type="video/ogg">
    </video> -->

    <!-- <img
      *ngIf="mostrarBannerDefault"
      class="banner-default"
      src="/assets/img/svg/Banner_home.svg"> -->

    <p class="texto-bienvenida">
        Se da la bienvenida al <span class="font-bold">Portal del
        Sistema de Información
        Universitaria,</span> una herramienta
        que consolida la oferta
        educativa de las universidades
        licenciadas de todo el Perú, con
        el objetivo de ayudarte a decidir
        tu futuro profesional.
      </p>

  </div>
</ng-container>
